import { GlobalState } from '@leverege/ui-redux';
import { Config } from '@leverege/plugin';
import { Auth } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import LinkAction from "../../../routes/LinkAction.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.screens.account.Account');
export default LinkAction.create({
  id: 'link.mobile.Account',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  path: '/account',
  startsWith: true,
  layout: {
    group: ['user'],
    groupIcons: [tIcon('profileMenuIcon')
    // () => { return Config.get( 'Main', 'userIcon', 'https://molten-ui-assets.storage.googleapis.com/user-profile.svg' ) } 
    ],
    groupNames: [() => {
      return GlobalState.get().auth?.profile?.name || Auth.getUsername(GlobalState.get().auth) || t('groupName');
    }],
    sort: 'a',
    sectionName: tf('sectionName')
  },
  handles: context => {
    return Auth.getProfile(GlobalState.get().auth) != null && context.mobile;
  },
  name: tf('name'),
  icon: Config.get('Main', 'accountIcon', 'https://molten-ui-assets.storage.googleapis.com/settings-account.png')
});